"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetLibrarySidebar = exports.FoldersHeading = exports.className = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("Common/AssetLibrary/Types");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var kaleidoscope_4 = require("@qwilr/kaleidoscope");
var icons_2 = require("@qwilr/kaleidoscope/icons");
var DashboardTypes_1 = require("Dashboard/DashboardTypes");
exports.className = "dashboard-sidebar";
exports.FoldersHeading = (0, mobx_react_1.observer)(function (props) {
    return react_1.default.createElement("div", { className: "".concat(exports.className, "__label text-context-label") }, props.children);
});
var AssetLibrarySidebar = (function (_super) {
    __extends(AssetLibrarySidebar, _super);
    function AssetLibrarySidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.isFolderBeingDragged = false;
        _this.createNewFolder = function (accountLevel) {
            if (accountLevel === void 0) { accountLevel = false; }
            var foldersViewStore = _this.props.foldersViewStore;
            if (foldersViewStore && foldersViewStore.allowCreatingFolder) {
                foldersViewStore.startCreatingFolder(accountLevel);
            }
        };
        return _this;
    }
    AssetLibrarySidebar.prototype.onFolderDragStart = function (event, folderId) {
        event.dataTransfer.effectAllowed = "move";
        var dragData = {
            type: DashboardTypes_1.DragDataType.SidebarFolder,
            folderToMove: folderId,
        };
        this.isFolderBeingDragged = true;
        event.dataTransfer.setData("application/json", JSON.stringify(dragData));
    };
    AssetLibrarySidebar.prototype.render = function () {
        var _a = this.props, assetLogoIcon = _a.assetLogoIcon, assetLogoLabel = _a.assetLogoLabel, rootFolder = _a.rootFolder;
        return (react_1.default.createElement("div", { className: "asset-library-sidebar" },
            react_1.default.createElement("div", { className: "asset-library-sidebar__logo" },
                react_1.default.createElement("div", { className: "asset-library-sidebar__logo-icon" }, assetLogoIcon),
                react_1.default.createElement("div", { className: "asset-library-sidebar__logo-text" }, assetLogoLabel)),
            react_1.default.createElement("div", { className: "asset-library-sidebar__folders" },
                react_1.default.createElement("div", { className: "asset-library-sidebar__explore-folders-header" }, "Explore"),
                react_1.default.createElement("div", { className: "asset-library-sidebar__folders-names" }, this.renderExploreFolders()),
                this.renderAccountFolders(),
                this.renderSystemFolder(rootFolder))));
    };
    AssetLibrarySidebar.prototype.renderExploreFolders = function () {
        var _this = this;
        var exploreFoldersList = this.props.exploreFoldersList;
        return react_1.default.createElement(react_1.default.Fragment, null, exploreFoldersList.map(function (id) { return _this.renderSystemFolder(id); }));
    };
    AssetLibrarySidebar.prototype.renderSystemFolder = function (id) {
        var _a = this.props, isFolderSelectionCleared = _a.isFolderSelectionCleared, selectedFolder = _a.selectedFolder, onFolderClick = _a.onFolderClick, onDropOnFolder = _a.onDropOnFolder;
        var disableDrop = this.invalidDropTargets.has(id);
        var onDrop = null;
        if (!!onDropOnFolder) {
            onDrop = function (event) {
                onDropOnFolder(event, id);
            };
        }
        return (react_1.default.createElement(kaleidoscope_1.FolderComponent, { name: Types_1.FolderNamesMapping[id] || "", key: id, icon: (0, Types_1.FolderIconsMapping)(icons_1.IconSize.Medium)[id] || react_1.default.createElement(react_1.default.Fragment, null), onClick: function () { return onFolderClick(id); }, selected: !isFolderSelectionCleared && selectedFolder === id, disableDrop: disableDrop, onDrop: onDrop }));
    };
    AssetLibrarySidebar.prototype.renderAccountFoldersHeading = function () {
        var _this = this;
        var foldersViewStore = this.props.foldersViewStore;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "asset-library-sidebar__account-folders-header" },
                react_1.default.createElement("div", null, "Account Folders"),
                react_1.default.createElement("div", { className: "asset-library-sidebar__folders-add", onMouseDown: function (e) {
                        e.stopPropagation();
                    } },
                    react_1.default.createElement(kaleidoscope_4.IconButton, { isRound: true, size: kaleidoscope_4.ButtonSize.Small, icon: react_1.default.createElement(icons_2.Add, null), type: kaleidoscope_4.ButtonType.Secondary, onClick: function () { return _this.createNewFolder(true); }, disabled: !foldersViewStore.allowCreatingFolder, tooltip: {
                            content: "Add folder",
                        } })))));
    };
    AssetLibrarySidebar.prototype.renderAccountFolders = function () {
        var _a = this.props, foldersViewStore = _a.foldersViewStore, onFolderClick = _a.onFolderClick, onDeleteFolder = _a.onDeleteFolder, onDropOnFolder = _a.onDropOnFolder;
        if (!foldersViewStore) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "asset-library-sidebar__custom-folders" },
            this.renderAccountFoldersHeading(),
            react_1.default.createElement("div", { onMouseDown: function (e) {
                    e.stopPropagation();
                } },
                react_1.default.createElement("div", { className: "asset-library-sidebar__folder-tree" },
                    react_1.default.createElement(kaleidoscope_3.FolderTree, { className: "asset-library-sidebar__my-folders", onDragStart: this.onFolderDragStart, onDragEnd: this.onFolderDragEnd, viewStore: foldersViewStore.accountFolderViewStore, maxNameLength: foldersViewStore.maxNameLength, onSelect: onFolderClick, onNameChange: foldersViewStore.onNameChange, onRenameConfirm: foldersViewStore.onRenameConfirm, onRenameCancel: foldersViewStore.onRenameCancel, onCreateFolder: foldersViewStore.onCreateChildFolder, onDeleteFolder: onDeleteFolder, onDropOnFolder: onDropOnFolder })))));
    };
    AssetLibrarySidebar.prototype.onFolderDragEnd = function () {
        this.isFolderBeingDragged = false;
    };
    Object.defineProperty(AssetLibrarySidebar.prototype, "invalidDropTargets", {
        get: function () {
            var e_1, _a, e_2, _b;
            var _c = this.props, exploreFoldersList = _c.exploreFoldersList, disableDropFolderIds = _c.disableDropFolderIds;
            var invalidDropTargets = new Set();
            if (this.isFolderBeingDragged) {
                try {
                    for (var exploreFoldersList_1 = __values(exploreFoldersList), exploreFoldersList_1_1 = exploreFoldersList_1.next(); !exploreFoldersList_1_1.done; exploreFoldersList_1_1 = exploreFoldersList_1.next()) {
                        var f = exploreFoldersList_1_1.value;
                        invalidDropTargets.add(f);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (exploreFoldersList_1_1 && !exploreFoldersList_1_1.done && (_a = exploreFoldersList_1.return)) _a.call(exploreFoldersList_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (!!disableDropFolderIds) {
                try {
                    for (var disableDropFolderIds_1 = __values(disableDropFolderIds), disableDropFolderIds_1_1 = disableDropFolderIds_1.next(); !disableDropFolderIds_1_1.done; disableDropFolderIds_1_1 = disableDropFolderIds_1.next()) {
                        var f = disableDropFolderIds_1_1.value;
                        invalidDropTargets.add(f);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (disableDropFolderIds_1_1 && !disableDropFolderIds_1_1.done && (_b = disableDropFolderIds_1.return)) _b.call(disableDropFolderIds_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            return invalidDropTargets;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AssetLibrarySidebar.prototype, "isFolderBeingDragged", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _a : Object, typeof (_b = typeof kaleidoscope_2.FolderTreeId !== "undefined" && kaleidoscope_2.FolderTreeId) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], AssetLibrarySidebar.prototype, "onFolderDragStart", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetLibrarySidebar.prototype, "onFolderDragEnd", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof Set !== "undefined" && Set) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], AssetLibrarySidebar.prototype, "invalidDropTargets", null);
    AssetLibrarySidebar = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AssetLibrarySidebar);
    return AssetLibrarySidebar;
}(react_1.default.Component));
exports.AssetLibrarySidebar = AssetLibrarySidebar;
